import { useToast } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import Button from "../Button/Button";
import CSS from "./styles.module.css";

const DocPage = ({ children, isActive }) => {
	const ContentRef = useRef(null);
	const toast = useToast();

	const handleCopy = async () => {
		try {
			var originalText,
				htmlText,
				blobHtml,
				blobText,
				data = "";

			if (document.querySelector("#contentContainer")) {
				originalText = document.querySelector("#contentContainer").innerText;
				htmlText = document.querySelector("#contentContainer").innerHTML;
				blobHtml = new Blob([htmlText], { type: "text/html" });
				blobText = new Blob([originalText], { type: "text/plain" });
				data = [
					new ClipboardItem({ "text/plain": blobText, "text/html": blobHtml }),
				];

				navigator.clipboard.write(data);

				toast({
					description: "Copied to Clipboard",
					status: "success",
					duration: 5000,
					isClosable: true,
					position: "bottom-left",
				});
			}
		} catch (error) {
			toast({
				description: "Oops! Something went wrong.",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}
	};

	const handleEdit = () => {
		document.getElementById("generatedContent").focus();
	};

	useEffect(() => {
		if (children && children !== "") {
			ContentRef.current.innerHTML = children;
		} else if (children === "") {
			ContentRef.current.innerHTML = "";
		}
	}, [children]);

	return (
		<div
			className={`${CSS.Container} ${isActive ? CSS.ContainerActive : ""} ${
				CSS.contentBody
			}`}
			id="generatedContent"
			contentEditable={true}
		>
			<span ref={ContentRef} id="contentContainer"></span>

			<div
				className={`${CSS.Actionables} ${"HiddenContent"}`}
				id="actionables"
				contentEditable={false}
			>
				<a href="https://dash.recooty.com/register?referral=ultra&http_referer=https%3A%2F%2Frecooty.com%2F">
					<Button leftIcon="rocket_launch" className={CSS.PostButton}>
						Post this Job to
						<br />
						250+ Job boards
					</Button>
				</a>
				<Button
					leftIcon="content_copy"
					onClick={handleCopy}
					className={CSS.CopyButton}
				>
					Copy
				</Button>
				<Button leftIcon="edit" onClick={handleEdit} className={CSS.CopyButton}>
					Edit
				</Button>
			</div>
		</div>
	);
};

export default DocPage;
